import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Observable } from 'rxjs';
import { HeaderContentType, AccessPortal } from './def/header-content';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { BaseContentService } from './base-content-service';
import { has } from 'lodash';

@Injectable()
export class HeaderContentService extends BaseContentService<
  HeaderContentType
> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, HeaderContentService.staticHeader);
  }

  get data$(): Observable<HeaderContentType> {
    if (!this.loaded) {
      return this.getHeaderData();
    }

    return of(this.data);
  }

  getHeaderData(): Observable<HeaderContentType> {
    const url = `${this.serviceBaseUrl}header`;
    return this.get<HeaderContentType>(url).pipe(
      map(data => {
        this.data = this.headerMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private headerMapper(data: HeaderContentType): HeaderContentType {
    if (!data) return;

    return data;
  }

  private static staticHeader: HeaderContentType = {
    pageName: 'header',
    data: [
      {
        heading: '',
        title: '',
        description: '',
        text: '',
        image: null,
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    mainLinks: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    topHeaderLinks: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    headerDropdown: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 1,
            image: {
              Alt: '',
              Border: '',
              Class: '',
              Height: 393,
              HSpace: 0,
              Src: '',
              VSpace: 0,
              Width: 392,
              MediaId: '8b453c94-9d75-496f-8c6e-e7a1f7812e62',
              Title: '',
              Language: {
                Name: 'en'
              }
            },
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 2,
            image: {
              Alt: '',
              Border: '',
              Class: '',
              Height: 393,
              HSpace: 0,
              Src: '',
              VSpace: 0,
              Width: 393,
              MediaId: 'e968f04f-8f5a-4ace-81e0-6fac13cb9da3',
              Title: '',
              Language: {
                Name: 'en'
              }
            },
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 3,
            image: {
              Alt: '',
              Border: '',
              Class: '',
              Height: 392,
              HSpace: 0,
              Src: '',
              VSpace: 0,
              Width: 393,
              MediaId: '6a29ebdd-5a15-41dd-9104-3558c5ee72dc',
              Title: '',
              Language: {
                Name: 'en'
              }
            },
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 4,
            image: {
              Alt: '',
              Border: '',
              Class: '',
              Height: 393,
              HSpace: 0,
              Src: '',
              VSpace: 0,
              Width: 392,
              MediaId: 'fa6bf7c6-8051-490a-9d29-7066c0116f11',
              Title: '',
              Language: {
                Name: 'en'
              }
            },
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 5,
            image: {
              Alt: '',
              Border: '',
              Class: '',
              Height: 393,
              HSpace: 0,
              Src: '',
              VSpace: 0,
              Width: 393,
              MediaId: '8f98f65e-5cd6-4e5b-b9ab-29ec9563b0a2',
              Title: '',
              Language: {
                Name: 'en'
              }
            },
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 6,
            image: {
              Alt: '',
              Border: '',
              Class: '',
              Height: 393,
              HSpace: 0,
              Src: '',
              VSpace: 0,
              Width: 393,
              MediaId: 'c30f55b2-2cfb-41f7-8a76-e368d97f586b',
              Title: '',
              Language: {
                Name: 'en'
              }
            },
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 7,
            image: {
              Alt: '',
              Border: '',
              Class: '',
              Height: 393,
              HSpace: 0,
              Src: '',
              VSpace: 0,
              Width: 393,
              MediaId: '26909231-b478-461b-aa2f-e95176e4c6b8',
              Title: '',
              Language: {
                Name: 'en'
              }
            },
            icon: ''
          }
        ]
      },
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '00000000-0000-0000-0000-000000000000',
              Type: 2,
              Style: ''
            },
            orderId: 1,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '00000000-0000-0000-0000-000000000000',
              Type: 2,
              Style: ''
            },
            orderId: 2,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '00000000-0000-0000-0000-000000000000',
              Type: 2,
              Style: ''
            },
            orderId: 3,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '00000000-0000-0000-0000-000000000000',
              Type: 2,
              Style: ''
            },
            orderId: 4,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '00000000-0000-0000-0000-000000000000',
              Type: 2,
              Style: ''
            },
            orderId: 5,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '00000000-0000-0000-0000-000000000000',
              Type: 2,
              Style: ''
            },
            orderId: 6,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: {
              Anchor: '',
              Class: '',
              Text: '',
              Query: '',
              Title: '',
              Url: '',
              Target: '',
              TargetId: '00000000-0000-0000-0000-000000000000',
              Type: 2,
              Style: ''
            },
            orderId: 7,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    topHeaderDropdown: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          }
        ]
      }
    ]
  };

  getProductMenu(displayItems) {
    const userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    // return prodList.filter(obj1 =>
    //   userDetails.PortalAccess.some(obj2 => obj1.keyText === obj2.Name)
    // );
    if (!has(userDetails, 'PortalAccess')) return [];
    userDetails.PortalAccess = [...userDetails.PortalAccess].map(
      (access): AccessPortal => {
        let result = displayItems.find(
          _sitecore => _sitecore.keyText === access.Name
        );
        if (result) {
          access.imageSrc = result.image.Src || '';
          access.OtherPolicyTypeIds = result.options.split(',') || [''];
        }
        return access;
      }
    );
    sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
    sessionStorage.setItem('isWrittenCommissionDisplayApplicable', userDetails.IsKraftLake?'N':'Y'); 
    return userDetails.PortalAccess;
  }

  topHeaderDropdown(topHeaderDropdownList){
    const userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    if( !userDetails?.AgentInfo?.HasSuretyAccess) {
     let index = topHeaderDropdownList.findIndex(x => x.keyText ==="Surety");
     topHeaderDropdownList.splice(index,1);     
    }
    if( !userDetails?.AgentInfo?.HasAdminAccess ) {
     let index = topHeaderDropdownList.findIndex(x => x.keyText ==="Agency Admin");
     topHeaderDropdownList.splice(index,1);     
    }
    return topHeaderDropdownList;
   }
}
